import { Outlet, createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/admin/guard';
import { TabNav } from '@/features/projects/tab-nav';
import { requireResourcesFeature } from '@/features/resources/guard';
import { resourceTexts } from '@/features/resources/texts';

const texts = resourceTexts.heatmap;

/** RES-05, RES-06: utilization of all people and job roles (resource.view_all). */
export const Route = createFileRoute('/_app/resources')({
  beforeLoad: async ({ context }) => {
    requirePermission(context.me, 'resource.view_all');
    await requireResourcesFeature(context.queryClient);
  },
  component: ResourcesLayout,
});

function ResourcesLayout() {
  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-3">
        <h1 className="text-2xl font-semibold">{texts.title}</h1>
        <TabNav
          label={texts.title}
          items={[
            { label: texts.tabs.people, link: { to: '/resources', search: {} }, exact: true },
            { label: texts.tabs.roles, link: { to: '/resources/roles', search: {} } },
          ]}
        />
      </div>
      <Outlet />
    </div>
  );
}
